import type { ListingDraft } from "../types";
import { Field, Input, Select } from "./ui";

export function SkuIdentityFields({ gtin, billbeeId, identityId, unit, onChange }: {
  gtin?: string;
  billbeeId?: string;
  identityId?: string;
  unit?: ListingDraft["skuUnit"];
  onChange: (value: Pick<ListingDraft, "gtin" | "billbeeId" | "identityId" | "skuUnit">) => void;
}) {
  return <div className="form-grid form-grid--two">
    <Field label="GTIN / EAN" hint="Wird aus dem Amazon-Katalog geprüft. Fehlt sie dort, bitte vom Artikel übernehmen.">
      <Input value={gtin ?? ""} maxLength={14} inputMode="numeric"
        onChange={event => onChange({ gtin: event.target.value, billbeeId, identityId, skuUnit: unit })} />
    </Field>
    <Field label="Verifizierte Billbee-Artikel-ID" hint="Optional, wenn bereits eine geprüfte zentrale Zuordnung zu diesem Artikel besteht.">
      <Input value={billbeeId ?? ""} maxLength={100}
        onChange={event => onChange({ gtin, billbeeId: event.target.value, identityId, skuUnit: unit })} />
    </Field>
    <Field label="Zentrale Artikel-ID" hint="Optional für einen bereits manuell geprüften Artikel, auch ohne GTIN. Die Verkaufseinheit muss zur zentralen Zuordnung passen.">
      <Input value={identityId ?? ""} maxLength={100}
        onChange={event => onChange({ gtin, billbeeId, identityId: event.target.value, skuUnit: unit })} />
    </Field>
    <Field label="Verkaufseinheit *" hint="Die GTIN muss genau zu dieser verkauften Einheit gehören.">
      <Select value={unit?.kind ?? ""} onChange={event => {
        const kind = event.target.value as NonNullable<ListingDraft["skuUnit"]>["kind"];
        onChange({ gtin, billbeeId, identityId, skuUnit: kind ? { kind, quantity: kind === "single" ? 1 : 2, variant: "" } : undefined });
      }}>
        <option value="">Bitte auswählen</option><option value="single">Einzelartikel</option>
        <option value="pack">Mehrfachpack</option><option value="bundle">Bundle / Set</option>
      </Select>
    </Field>
    {unit && unit.kind !== "single" && <Field label="Anzahl im Pack / Set *">
      <Input type="number" min={2} max={10000} value={unit.quantity}
        onChange={event => onChange({ gtin, billbeeId, identityId, skuUnit: { ...unit, quantity: Number(event.target.value) } })} />
    </Field>}
    {unit && <Field label="Variante" hint="Nur ausfüllen, wenn die verkaufte Einheit eine feste Variante hat.">
      <Input value={unit.variant ?? ""} maxLength={160}
        onChange={event => onChange({ gtin, billbeeId, identityId, skuUnit: { ...unit, variant: event.target.value } })} />
    </Field>}
  </div>;
}
